import { render, staticRenderFns } from "./DadosIniciais.vue?vue&type=template&id=3e246b36&scoped=true&"
import script from "./DadosIniciais.vue?vue&type=script&lang=js&"
export * from "./DadosIniciais.vue?vue&type=script&lang=js&"
import style0 from "./DadosIniciais.vue?vue&type=style&index=0&id=3e246b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e246b36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VFlex,VForm,VTextField})
